import React from "react";
import { Routes, Route } from "react-router-dom";

import DashboardLayout from "../layouts/DashboardLayout.jsx";

import Profile from "../pages/dashboard/Profile.jsx";
import DashboardHome from "../pages/dashboard/DashboardHome.jsx";
import ViewCourse from "../pages/dashboard/ViewCourse.jsx";
import CreateCourse from "../pages/dashboard/CreateCourse.jsx";
import ChangePassword from "../pages/dashboard/ChangePassword.jsx";
import NewAdmin from "../pages/dashboard/NewAdmin.jsx";
import CreatePricing from "../pages/dashboard/CreatePricing.jsx";
import EditCourse from "../pages/dashboard/EditCourse.jsx";
import ViewPlan from "../pages/dashboard/ViewPricingPlan.jsx";
import ViewAdmin from "../pages/dashboard/ViewAdmin.jsx";

const DashboardRoute = () => {
    return (
        <Routes>
            <Route element={<DashboardLayout />}>
                <Route path="/" element={<DashboardHome />} />
                <Route path="/view-admin" element={<ViewAdmin/>} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/view-course" element={<ViewCourse />} />
                <Route path="/create-course" element={<CreateCourse />} />
                <Route path="/edit-course" element={<EditCourse/>}/>
                <Route path="/create-pricing" element={<CreatePricing />} />
                <Route path="/view-plan" element={<ViewPlan />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/admin" element={<NewAdmin />} />
            </Route>
        </Routes>
    );
};

export default DashboardRoute;
